module.exports = __webpack_public_path__ + "img/lock-red.095bfbf0.svg";